import IntlService from 'services/intl/IntlService';
import { ProcessingType } from './interfaces/paymentMethods';
import messages from 'modules/pos-settings/messages/messages';

export const getProcessingTypeLabel = (processingType: ProcessingType) => {
  switch (processingType) {
    case ProcessingType.InClubTerminal:
      return IntlService.formatMessage(messages.inClubTerminalLabel);
    case ProcessingType.Peak:
      return IntlService.formatMessage(messages.peakLabel);
    default:
      return '';
  }
};
